import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import ApartmentFields from './ApartmentFields'

export const ApartmentViewCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" >
      <Grid container spacing={8}>
        <ApartmentFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default ApartmentViewCreate
